import React from 'react';
import { withLocalize } from "react-localize-redux";
import AddressRow from './identData/addressRow';
import BasicRow from './identData/basicRow';
import HistoryRow from './identData/historyRow';
import NacesRow from './identData/nacesRow';

import "./identData.scss";

class MirriIdentData extends React.Component {
    state = { detailExpanded: false };

    shouldComponentUpdate(nextProps, _) {
        return this.props.dataHash !== nextProps.dataHash;
    }

    render() {
        return (this.props.data === undefined || this.props.data === null ? "" : <div>{this.renderContent(this.props.data)}</div>);
    }

    renderContent(data) {
        let isCustomizableMspReport = this.props.reportType === "CustomizableMspReport";

        return (
            <div className="ident-data">
                <HistoryRow name={data.companyName} from={data.from} source={data.companyNameSource} SourceFullCompany={data.companyNameSource} primaryNamesUngrouped={data.primaryNamesUngrouped} historyNames={data.historyNames} primaryNames={data.primaryNames} />
                <AddressRow address={data.fullAddress} addressSource={data.fullAddressSource} historyAddresses={data.historyAddresses} sourceFullName={data.SourceFullName} primaryAddressFrom={data.fullAddressFrom} />
                <BasicRow title="Report.CompanyIdentification.LegalForm" value={data.legalForm} />
                {!isCustomizableMspReport && <BasicRow title="Report.CompanyIdentification.FactWording" value={data.factWording} />}
                {isCustomizableMspReport && <NacesRow title="Report.CompanyIdentification.PrimaryNace" value={data.primaryNaces} />}
                <BasicRow title="Report.CompanyIdentification.Ico" value={data.companyId} />
                <BasicRow title="Report.CompanyIdentification.TaxId" value={data.taxId} />
                <BasicRow title="Report.CompanyIdentification.VatId" value={data.vatId} />
                {!isCustomizableMspReport && <BasicRow title={data.taxManagerBankAccountLabel} value={data.taxManagerBankAccount} doNotTranslateTitle />}
                <BasicRow title="Report.CompanyIdentification.DateOfRegistration" value={data.creationDate} />
                <BasicRow title="Report.CompanyIdentification.DateOfDissolution" value={data.dissolutionDate} />
            </div>
        )
    }
}

export default withLocalize(MirriIdentData);
